import React, { Component, Fragment } from 'react';
import Switch from '@material-ui/core/Switch';
import { Navigationmenu } from '../components';
import {
  Box,
  Button,
  Typography,
  Grid,
  Divider,
  MuiEditableLabel,
  TextField,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Popover,
  Dialog,
  Tabs,
  Tab,
  DialogActions,
  withStyles,
  TableFooter
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  SearchOutlined,
  ArrowDropDown,
  Publish,
  NoteAdd,
  ArrowDropUp,
  InsertDriveFileOutlined,
  AlternateEmail,
  AlternateEmailTwoTone
} from '@material-ui/icons';
import {
  ALTERNATEROW_BACKGROUND_COLOR,
  BLUE_COLOR, LIGHTGRAY_COLOR,
  MODIFIEDBLACK,
  PINK_COLOR,
  PROTECT_GREEN,
  RED_COLOR,
  VIBRANT_GREEN
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import axios from "axios"
import { findAllByPlaceholderText } from '@testing-library/react';
import { fnPostapiResponse, fnGETapiResponse, Isadmintoggleusers } from '../APICall';

import { Link } from '@material-ui/core';
import RBMScreenImg from '../gallery/RBMScreenImg.jpg';
const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    backgroundColor: 'white',
    height: 3
  },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: 'white',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    '&:focus': {
      opacity: 1
    }
  },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);

export default class CDDCRM extends Component {

  state = {
    tablebuffer: [],
    pages: 0,
    current: 1,
    records: 0,
    pageSize: 10,
    showPager: false,
    SOURCE: "",
    FNAME: "",
    SNAME: "",
    pagesObj: [],
    OWNERTYPE: [],
    PRODUCT: [],
    PREMIUM: [],
    NATIONALITY: [],
    COUNTRY: [],
    TSECTOR: [],
    INTRO: [],
    BENEF: [],
    SRCFUND: [],
    PEP: [],
    AML: [],
    COMPLEX: [],
    CINCORP: [],
    CompanyType: [],
    ClientType: [],
    Occupation: [],
    SelectedOwnerType: "",
    SelectedProductType: "",
    SelectedPREMIUMType: "",
    SelectedNATIONALITYType: "",
    SelectedCOUNTRYYType: "",
    SelectedTSECTORType: "",
    SelectedTSECTORText: "",
    SelectedINTROType: "",
    SelectedBENEFType: "",
    SelectedSRCFUNDType: "",
    SelectedPEPType: "",
    SelectedAMl: "",
    SelectedCOMPLEXType: "NO",
    SelectedCINCORPType: "",
    SelectedOccupationType: "",
    SelectedOwnerTypeSCORE: 0,
    SelectedProductTypeSCORE: 0,
    SelectedPREMIUMTypeSCORE: 0,
    SelectedNATIONALITYTypeSCORE: 0,
    SelectedCOUNTRYTypeSCORE: 0,
    SelectedTSECTORTypeSCORE: 0,
    SelectedINTROTypeSCORE: 0,
    SelectedBENEFTypeSCORE: 0,
    SelectedSRCFUNDTypeSCORE: 0,
    SelectedPEPTypeSCORE: 0,
    SelectedAMLSCORE: 0,
    SelectedCOMPLEXTypeSCORE: 1,
    SelectedCINCORPTypeSCORE: 0,
    SelectedOccupationTypeScore: 0,
    SelectedCompany: '',
    SelectedClientName: "",
    SelectedClientType: "",
    SelectedNICType: "",
    SelectedNicLabel: "",
    selectedDropCountry: "MUS",
    Dropcountry: [],
    NICdrop: [],
    nivvaliderror: "",
    SelectedBRN: "", SelectedNic: "",
    selectedProductLabel: "Product Type :",
    selectedPremiumLabel: "Amount of Premium :",
    displaycountry: "none",
    selectedbeneficiaryLabel: "",
    TotalRiskCount: 0,
    selectedDate: "",
    riskProfile: "",
    showBeneficiaryComponent: false,
    showNewCDDC: false,
    validateAlloptions: false,
    SavebuttonDisable: false,
    savebuttonbackcolor: BLUE_COLOR,
    isadmin: false,
    isadminSwitch: false,
    ShowOccupation: false,
    diableRadio: true,
    BeneFitPayble: false,
    ChckOnboarding: true,
    disableSelectedINTROType: false,
    disableSelectedpaymentType: false,
    disableBenef: false,
    Nainpayment: true,
    NANSourceOfFund: true,
    NANSourceOfIntroduction: true,
    NANBenef: true,
    clearresult: true

  }
  handleChange = (event) => {
    this.setState({ isadmin: event.target.checked });
  };
  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  handleLeavePage(e) {
    const confirmationMessage = 'My message';
    e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
    return confirmationMessage;              // Gecko, WebKit, Chrome <34
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleLeavePage)
    // Check User for IsAdmin Control
    var IsadminflagUsers = Isadmintoggleusers()
    var allowIsadminflagUsersAccess = false
    // IsadminflagUsers.forEach(element => {
    //     if (sessionStorage.getItem('isadminFlag') == "true" || sessionStorage.getItem('username') == element) { 
    //       allowIsadminflagUsersAccess = true
    //      }
    // });
    if (allowIsadminflagUsersAccess) {
      this.setState({ isadmin: true, isadminSwitch: false })
    }
    else {
      this.setState({ isadmin: false, isadminSwitch: true })
    }
    var date = new Date()
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
    var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
    this.state.selectedDate = date.getFullYear() + "" + month + date1
    // alert(this.state.selectedDate)
    var data = {
      "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
      "MAPINAME": 'GETCDDCRMDDL',
      "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
      "body": ''
    }
    fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
      var data = response.data
      console.log("chckCountr", data)
      if (data["OWNERTYP"] != undefined) {
        this.setState({
          OWNERTYPE: data["OWNERTYP"][0],
          //PREMIUM:data["PREMIUM"][0],
          NATIONALITY: data["NATIONALITY"][0],
          COUNTRY: data["COUNTRY"][0],
          Dropcountry: data["COUNTRY"][0],
          TSECTOR: data["TSECTOR"][0],
          INTRO: data["INTRO"][0],
          //BENEF:data["BENEF"][0],
          SRCFUND: data["SRCFUND"][0],
          PEP: data["PEP"][0],
          AML: data["AML"][0],
          COMPLEX: data["COMPLEX"][0],
          CINCORP: data["CINCORP"][0],
          CompanyType: data["Company"][0],
          ClientType: data["ClientType"][0],
          SelectedCompany: "SWAN GENERAL",
          SelectedClientType: "CORPORATE",
          SelectedClientName: "",
          SelectedBRN: ""
        });
        this.fnsetclientType("CORPORATE")
        this.FntoSetProductypes("PRODUCTSGL")
        this.setState({
          selectedOption: "ONBOARDING"
        });
        this.setRadioState("ONBOARDING");
      }
      else {
        alert(data)
      }
      this.fnsetdatafromurl()
    }).catch(e => console.log(e));
  }
  fnsetdatafromurl() {
    // this.state.selectedUser = sessionStorage.getItem('username')
    //     this.state.selectedPass = sessionStorage.getItem('password')
    //     this.state.IsWindowsAuth = sessionStorage.getItem('IsWindowsAuth')
    // this.state.SelectedNic = sessionStorage.getItem("NIC")
    // alert(sessionStorage.getItem('ClientNo'))

    this.state.SelectedClientName = sessionStorage.getItem('ClientNo')
    this.setState({ SelectedCompany: sessionStorage.getItem('Company') })
    this.state.SelectedClientType = sessionStorage.getItem('ClientType')
    // this.state.selectedDropCountry = sessionStorage.getItem('Country')
    // var nic = this.state.SelectedNic.split("-")
    // // console.log("NIC Wala",nic)
    // if (nic.length > 1) {
    //     this.state.SelectedNICType = nic[0]
    //     this.state.SelectedNic = nic[1]
    // }
    // else {
    //     this.state.NICdrop = "NIC"
    //     this.state.SelectedNic = nic[0]
    // }
    this.fnsetclientType(this.state.SelectedClientType)

    if (sessionStorage.getItem('isFromWindowApplication')) {
      let cmp = sessionStorage.getItem('Company')

      this.setState({
        selectedOption: "ONBOARDING"
      });
      this.FntoSetProductypes(cmp)

    }

  }

  FntocheckpassDrop(pasdrp) {
    if (pasdrp == "PAS" || pasdrp == "LEI" || pasdrp == "CRN") {
      this.setState({ displaycountry: "block" })
    }
    else {
      this.setState({ displaycountry: "none" })
    }

  }
  fnsetclientType(clnttype) {
    var data =
    {
      "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
      "MAPINAME": 'GETNICBRN',
      "MAPIPORT": process.env.REACT_APP_MPORT,
      "body": clnttype
    }
    fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
      this.setState({ NICdrop: response.data["nicbrnval"][0] })
      // console.log("ddd",this.state.NICdrop)
      if (
        clnttype == "CORPORATE"
      )

        this.setState({
          SelectedNICType: "BRN",
          SelectedNicLabel: "BRN"
        })
      else {
        this.setState({
          SelectedNICType: "NIC",
          SelectedNicLabel: "NIC"
        })
      }
      this.FntocheckpassDrop(this.state.SelectedNICType)
    }).catch(e => console.log(e));

  }
  isEven(n) {
    return n % 2 == 0;
  }
  handleCancelClick() {
    var r = window.confirm("Do you really want Cancel ?")
    if (r == true)
      window.location.reload();
  }
  handleNewCDDClick() {
    var r = window.confirm("Do you really want to calculate New Risk Profiling ?")
    if (r == true) {
      this.clearrelaod()
    }

  }

  clearrelaod() {
    this.state.riskProfile = ""
    this.state.ShowOccupation = false
    this.state.SelectedTSECTORText = ""
    this.state.SelectedNic = ""
    this.state.SelectedCompany = ""
    this.state.SelectedClientName = ""
    this.state.SelectedClientType = ""
    this.state.SelectedNICType = ""
    this.state.SelectedBRN = ""
    this.state.SelectedNicLabel = ""
    this.state.SelectedCINCORPType = ""
    this.state.SelectedOwnerType = ""
    this.state.SelectedOwnerTypeSCORE = 0
    this.state.SelectedProductType = ""
    this.state.SelectedProductTypeSCORE = 0
    this.state.SelectedPREMIUMType = ""
    this.state.SelectedPREMIUMTypeSCORE = 0
    this.state.SelectedNATIONALITYType = ""
    this.state.SelectedNATIONALITYTypeSCORE = 0
    this.state.SelectedCOUNTRYYType = ""
    this.state.SelectedCOUNTRYTypeSCORE = 0
    this.state.SelectedTSECTORType = ""
    this.state.SelectedTSECTORTypeSCORE = 0
    this.state.SelectedINTROType = ""
    this.state.SelectedINTROTypeSCORE = 0
    this.state.SelectedSRCFUNDType = ""
    this.state.SelectedSRCFUNDTypeSCORE = 0
    this.state.SelectedPEPType = ""
    this.state.SelectedPEPTypeSCORE = 0
    this.state.SelectedAMl = ""
    this.state.SelectedAMLSCORE = 0
    this.state.SelectedCOMPLEXType = ""
    this.state.SelectedCOMPLEXTypeSCORE = 0
    this.state.SelectedBENEFType = ""
    this.state.SelectedBENEFTypeSCORE = 0
    this.setState({
      SelectedCompany: "",
      SavebuttonDisable: false,
      savebuttonbackcolor: BLUE_COLOR,
      showNewCDDC: false

    })
  }
  handeltextChange(e, key) {
    this.setState({ key: e.target.value });
    this.state[key] = e.target.value;
    // alert("change "+ this.state.NIC+"")

  }
  Nicchecking() {
    if (this.state.SelectedNic.trim() == "") {
      alert("Please select either NIC or BRN")
    }
    else {
      var data =
      {
        "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
        "MAPINAME": 'ValidateNIC',
        "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
        "body": {
          "strFirstCharToCheck": "",
          "strSurname": "",
          "strMaiden": "",
          "strSex": "",
          "strDOB": "",
          "strCountryCode": "",
          "strNic": this.state.SelectedNic.trim(),
          "strStatus": "",
          "strMessage": "",
          "blCheckDigitOnly": true
        }
      }
      fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
        this.state.nivvaliderror = response.data
        if (this.state.nivvaliderror == true || this.state.SelectedBRN.trim() != "" || this.state.SelectedNICType != "NIC") {
          this.FntovalidateDrop()
          if (this.state.validateAlloptions) {
            this.FntoSumScore()

            var data1 =
            {
              "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
              "MAPINAME": 'getrisk',
              "MAPIPORT": process.env.REACT_APP_MPORT,
              "body": this.state.TotalRiskCount
            }
            fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response2) => {
              var data = response2.data
              this.setState({
                riskProfile: data,
              });
              this.saveData()
            }).catch(e => console.log(e));
          }
        }
        else {
          alert(this.state.nivvaliderror)
        }
      }).catch(e => console.log(e),
      );
    }
  }

  handleSearchClick(e) {
    this.setState({ showalertPopup: true })
  }
  handlesetalert(value) {
    if (value == "NO")
      this.Nicchecking()
    this.setState({ showalertPopup: false })
  }
  FntovalidateDrop() {

    // console.log("",this.state.SelectedOwnerType + " Pt " +  this.state.SelectedProductType + " Premium " + this.state.SelectedPREMIUMType 
    // + " NAtion " +this.state.SelectedNATIONALITYType+ " country " + this.state.SelectedCOUNTRYYType + " tsec " +this.state.SelectedTSECTORType
    // + " introd " +this.state.SelectedINTROType+ " srcfund " + this.state.SelectedSRCFUNDType+ " Pepty " +this.state.SelectedPEPType
    // + " aml " +this.state.SelectedAMl+ " comp " +this.state.SelectedCOMPLEXType + " oinco " + this.state.SelectedCINCORPType)




    if (this.state.SelectedOwnerType == "" || this.state.SelectedProductType == "" || this.state.SelectedPREMIUMType == "" ||
      this.state.SelectedNATIONALITYType == "" || this.state.SelectedCOUNTRYYType == "" || this.state.SelectedTSECTORType == "" ||
      this.state.SelectedINTROType == "" || this.state.SelectedSRCFUNDType == "" || this.state.SelectedPEPType == "" ||
      this.state.SelectedAMl == "" || this.state.SelectedCOMPLEXType == "") {
      alert("All dropdowns must be filled to proceed.")
      this.state.validateAlloptions = false
    } else
      this.state.validateAlloptions = true
  }
  clearddlvalueswithscores() {
    // this.state.SelectedNic = ""
    // this.state.SelectedBRN = ""
    // this.state.SelectedClientName = ""
    this.state.SelectedCINCORPType = ""
    this.state.SelectedOwnerType = ""
    this.state.SelectedOwnerTypeSCORE = 0
    this.state.SelectedProductType = ""
    this.state.SelectedProductTypeSCORE = 0
    this.state.SelectedPREMIUMType = ""
    this.state.SelectedPREMIUMTypeSCORE = 0
    this.state.SelectedNATIONALITYType = ""
    this.state.SelectedNATIONALITYTypeSCORE = 0
    this.state.SelectedCOUNTRYYType = ""
    this.state.SelectedCOUNTRYTypeSCORE = 0
    this.state.SelectedTSECTORType = ""
    this.state.SelectedTSECTORTypeSCORE = 0
    this.state.SelectedINTROType = ""
    this.state.SelectedINTROTypeSCORE = 0
    this.state.SelectedSRCFUNDType = ""
    this.state.SelectedSRCFUNDTypeSCORE = 0
    this.state.SelectedPEPType = ""
    this.state.SelectedPEPTypeSCORE = 0
    this.state.SelectedAMl = ""
    this.state.SelectedAMLSCORE = 0
    this.state.SelectedCOMPLEXType = ""
    this.state.SelectedCOMPLEXTypeSCORE = 0
    this.state.SelectedBENEFType = ""
    this.state.SelectedBENEFTypeSCORE = 0
  }



  saveData() {

    var NICandBRNValue = ""
    if (this.state.SelectedNICType == "PAS") {
      NICandBRNValue = "PASS-" + this.state.SelectedNic.trim() + "-" + this.state.selectedDropCountry
    }
    else
      NICandBRNValue = this.state.SelectedNICType + "-" + this.state.SelectedNic.trim()
    // POST request 
    var data1 =
    {
      "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
      "MAPINAME": 'POSTCDDCRMDDL',
      "MAPIPORT": process.env.REACT_APP_MPORT,
      "body": {
        "NIC": "" + NICandBRNValue + "",
        "companyId": "" + this.state.SelectedCompany + "",
        "clientId": "" + this.state.SelectedClientName + "",
        "RISK_PROFILE": "" + this.state.riskProfile.toUpperCase() + "",
        "TOTAL_RISK_SCORE": "" + this.state.TotalRiskCount + "",
        "PRODUCT_CD": "" + this.state.SelectedProductType + "",
        "PRODUCT_SCORE": "" + this.state.SelectedProductTypeSCORE + "",
        "PREMIUM_CD": "" + this.state.SelectedPREMIUMType + "",
        "PREMIUM_SCORE": "" + this.state.SelectedPREMIUMTypeSCORE + "",
        "NATIONALITY_CD": "" + this.state.SelectedNATIONALITYType + "",
        "NATIONALITY_SCORE": "" + this.state.SelectedNATIONALITYTypeSCORE + "",
        "TSECTOR_CD": "" + this.state.SelectedTSECTORType + "",
        "TSECTOR_SCORE": "" + this.state.SelectedTSECTORTypeSCORE + "",
        "TSECTOR_TEXT": "" + this.state.SelectedTSECTORText + "",
        "INTRO_CD": "" + this.state.SelectedINTROType + "",
        "INTRO_SCORE": "" + this.state.SelectedINTROTypeSCORE + "",
        "BENEF_CD": "" + this.state.SelectedBENEFType + "",
        "BENEF_SCORE": "" + this.state.SelectedBENEFTypeSCORE + "",
        "SRCFUND_CD": "" + this.state.SelectedSRCFUNDType + "",
        "SRCFUND_SCORE": "" + this.state.SelectedSRCFUNDTypeSCORE + "",
        "PEP_CD": "" + this.state.SelectedPEPType + "",
        "PEP_SCORE": "" + this.state.SelectedPEPTypeSCORE + "",
        "AML_CD": "" + this.state.SelectedAMl + "",
        "AML_SCORE": "" + this.state.SelectedAMLSCORE + "",
        "COMPLEX_CD": "" + this.state.SelectedCOMPLEXType + "",
        "COMPLEX_SCORE": "" + this.state.SelectedCOMPLEXTypeSCORE + "",
        // "UBO_LOCATION_CD": "" + this.state.SelectedCOUNTRYYType + "",
        // "UBO_LOCATION_SCORE": "" + this.state.SelectedCOUNTRYTypeSCORE + "",
        "REG_ADDRESS_CD": "" + this.state.SelectedCOUNTRYYType + "",
        "REG_ADDRESS_SCORE": "" + this.state.SelectedCOUNTRYTypeSCORE + "",
        "OWNERTYPE_CD": "" + this.state.SelectedOwnerType + "",
        "OWNERTYPE_SCORE": "" + this.state.SelectedOwnerTypeSCORE + "",
        "COUNTRY_INCORP_CD": "" + this.state.SelectedCINCORPType + "",
        "COUNTRY_INCORP_SCORE": "" + this.state.SelectedCINCORPTypeSCORE + "",
        "CLIENT_TYPE": "" + this.state.SelectedClientType + "",
        "USERID": "" + sessionStorage.getItem("username").toUpperCase() + "",
        "DATE_ENTERED": "" + this.state.selectedDate + ""
      }
    }
    fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
      var data = response.data
      if (data == "Data Already Exist ") {
        this.setState({
          SavebuttonDisable: false,
          savebuttonbackcolor: BLUE_COLOR,
          showNewCDDC: false
        });
        alert("Client already has a risk profile for this product.");

      }
      else {
        alert("Risk profile is: " + this.state.riskProfile + ". Record has been successfully saved! Please proceed with CDD.")
        this.setState({
          SavebuttonDisable: true,
          savebuttonbackcolor: LIGHTGRAY_COLOR,
          showNewCDDC: true
        });
      }
    }).catch(e => console.log(e));
  }
  FnforotherOccupation(Newpcc, e) {
    // alert(Newpcc)
    this.setState({
      SelectedTSECTORType: e.target.value,
      SelectedTSECTORTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
    })
    if (e.target.value == "OTH") {


      var data1 =
      {
        "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
        "MAPINAME": 'getOccupation',
        "MAPIPORT": process.env.REACT_APP_MPORT,
        "body": Newpcc
      }
      fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response2) => {
        var data = response2.data
        this.setState({
          Occupation: data[0],
          ShowOccupation: true
        })
      }).catch(e => console.log(e));
    }
    else {
      this.state.ShowOccupation = false
    }
  }

  SetDDLComapnyValues(e) {
    var SelectedProType = "PRODUCTSGL"
    var SelectedPrimeum = "PREMIUMSGL"
    var SelectedPribenf = ""
    switch (e) {
      case 'SWAN LIFE':
        this.state.diableRadio = false
        this.state.selectedProductLabel = "Product Type :"
        this.state.selectedPremiumLabel = "Amount of Monthly/Single Premium :"
        this.state.selectedbeneficiaryLabel = "Do you know the beneficiary of the policy (SLL) :"
        this.state.showBeneficiaryComponent = true
        SelectedProType = "PRODUCTSLL"
        SelectedPrimeum = "PREMIUMSLL"
        SelectedPribenf = "OPTQ1SLL"
        break;
      case 'SWAN GENERAL':
        this.state.diableRadio = true
        this.state.selectedProductLabel = "Product Type :"
        this.state.selectedPremiumLabel = "Amount of Premium :"
        this.state.showBeneficiaryComponent = false
        SelectedProType = "PRODUCTSGL"
        SelectedPrimeum = "PREMIUMSGL"
        SelectedPribenf = ""
        break;
      case 'SWAN WEALTH':
        this.state.diableRadio = true
        this.state.selectedProductLabel = "Product / Service Type :"
        this.state.selectedPremiumLabel = "Amount of Investment :"
        SelectedProType = "PRODUCTSWL"
        SelectedPrimeum = "PREMIUMSWL"
        SelectedPribenf = ""
        this.state.showBeneficiaryComponent = false
        break;
      case 'SWAN PENSIONS':
        this.state.diableRadio = false
        this.state.selectedProductLabel = "Product Type :"
        this.state.selectedPremiumLabel = "Amount of Contribution :"
        this.state.selectedbeneficiaryLabel = "Number of Members :"
        this.state.showBeneficiaryComponent = true
        SelectedProType = "PRODUCTSPL"
        SelectedPrimeum = "PREMIUMSPL"
        SelectedPribenf = "OPTQ1SPL"
        break;
      case 'SWAN SECURITIES':
        this.state.diableRadio = false
        this.state.selectedProductLabel = "Product / Service Type :"
        this.state.selectedPremiumLabel = "Amount of Investment :"
        this.state.selectedbeneficiaryLabel = "Has there been allegations against Client ?"
        this.state.showBeneficiaryComponent = true
        SelectedProType = "PRODUCTSSL"
        SelectedPrimeum = "PREMIUMSSL"
        SelectedPribenf = "OPTQ1SSL"
        break;
      case 'SWAN SSR':
        this.state.diableRadio = true
        this.state.selectedProductLabel = "Product / Service Type :"
        this.state.selectedPremiumLabel = "Amount of Investment :"
        this.state.showBeneficiaryComponent = false
        // SelectedProType = "PRODUCTSSR"
        // SelectedPrimeum = "PREMIUMSSR"
        SelectedProType = "PRODUCTSGL"
        SelectedPrimeum = "PREMIUMSGL"
        SelectedPribenf = ""
        break;
      default:
        this.state.selectedProductLabel = "Product Type :"
        this.state.selectedPremiumLabel = "Amount of Contribution :"
        this.state.selectedbeneficiaryLabel = "Number of Members :"
        SelectedProType = "PRODUCTSGL"
        SelectedPrimeum = "PREMIUMSGL"
        SelectedPribenf = ""
        break;
    }
    return [SelectedProType, SelectedPrimeum, SelectedPribenf]
  }

  FntoSetProductypes(e) {
    // alert(e)
    this.clearddlvalueswithscores()
    var SelectedProType = "PRODUCTSGL"
    var SelectedPrimeum = "PREMIUMSGL"
    var SelectedPribenf = ""

    this.setState({
      selectedOption: "ONBOARDING"
    });
    this.setRadioState("ONBOARDING");
    var getSelectedValues = this.SetDDLComapnyValues(e)
    SelectedProType = getSelectedValues[0]
    SelectedPrimeum = getSelectedValues[1]
    SelectedPribenf = getSelectedValues[2]

    var data1 =
    {
      "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
      "MAPINAME": 'getOccupation',
      "MAPIPORT": process.env.REACT_APP_MPORT,
      "body": SelectedProType
    }
    fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response2) => {
      var data = response2.data
      this.setState({
        PRODUCT: data[0]
      })
    }).catch(e => console.log(e));

    var data1 =
    {
      "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
      "MAPINAME": 'getOccupation',
      "MAPIPORT": process.env.REACT_APP_MPORT,
      "body": SelectedPrimeum
    }
    fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response2) => {
      var data = response2.data
      this.setState({
        PREMIUM: data[0].sort(this.GetSortOrderfn("SCORE"))
      })
    }).catch(e => console.log(e));


    if (SelectedPribenf != "") {
      var data1 =
      {
        "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
        "MAPINAME": 'getOccupation',
        "MAPIPORT": process.env.REACT_APP_MPORT,
        "body": SelectedPribenf
      }
      fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response2) => {
        var data = response2.data
        this.setState({
          BENEF: data[0]
        })
      }).catch(e => console.log(e));
    }
  }

  setRadioState(e) {
    this.clearddlvalueswithscores()
    this.setState({
      selectedOption: e
    });

    if (e == "ONBOARDING") {
      this.setState({
        disableSelectedINTROType: false,
        SelectedINTROType: "", SelectedSRCFUNDType: "", disableBenef: false, SelectedBENEFType: ""
        , Nainpayment: true, disableSelectedpaymentType: false
        , NANBenef: true, NANSourceOfFund: true, NANSourceOfIntroduction: true

      })
      if (this.state.SelectedCompany != "") {
        this.SetDDLComapnyValues(this.state.SelectedCompany)
      }

    }
    else {
      this.setState({
        selectedPremiumLabel: "Amount Of Benefit Payable", SelectedINTROType: "NA"
        , disableSelectedINTROType: true, disableSelectedpaymentType: false, SelectedSRCFUNDType: "NA"
        , disableBenef: false, SelectedBENEFType: "", Nainpayment: false, NANBenef: true
        , NANSourceOfFund: false, NANSourceOfIntroduction: false, disableSelectedpaymentType: true, SelectedPREMIUMType: "NA"
      })
      if (this.state.SelectedCompany == "SWAN LIFE" || this.state.SelectedCompany == "SWAN PENSIONS") {
        this.setState({ disableBenef: true, SelectedBENEFType: "NA", NANBenef: false })
      }
    }

  }

  //Comparer Function    
  GetSortOrderfn(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    }
  }

  FntoSumScore() {
    this.state.TotalRiskCount = this.state.SelectedOwnerTypeSCORE + this.state.SelectedProductTypeSCORE +
      this.state.SelectedPREMIUMTypeSCORE + this.state.SelectedNATIONALITYTypeSCORE + this.state.SelectedCOUNTRYTypeSCORE +
      this.state.SelectedTSECTORTypeSCORE + this.state.SelectedINTROTypeSCORE + this.state.SelectedBENEFTypeSCORE +
      this.state.SelectedSRCFUNDTypeSCORE + this.state.SelectedPEPTypeSCORE + this.state.SelectedAMLSCORE +
      this.state.SelectedCOMPLEXTypeSCORE + this.state.SelectedCINCORPTypeSCORE;
  }
  render() {

    //  let planets = this.state.AML;
    //  console.log("Finallu",planets)
    // let optionItems = planets.map((planet) =>
    //         <option >{planet.DESCRIPTION}</option>
    //     );
    return (
      // <Fragment>
      //   {this.state.redirect &&
      //     <Redirect to={this.state.direction} />
      //   }
      //   <Navigationmenu selectedMenu={'CDDCRM'} />
      //   <div>
      //     <center style={{ marginTop:70 }}>
      //       <h1><u  style={{ borderWidth: 0, color: BLUE_COLOR,  fontFamily: 'Globerbold', fontSize: 30,}}>
      //         <Link href="http://svr-vm-swnwebap:7002/#/ConsPgm" target="_blank" rel="noopener noreferrer">
      //             Below screen is moved to new URL. Please click here and login into new URL.
      //         </Link></u>
      //       </h1>
      //       <img style={{filter:'grayscale(100%)'}} src={RBMScreenImg}></img>
      //     </center>
      //   </div>
      // </Fragment>
      <Fragment>
        <Navigationmenu selectedMenu={'CDDCRM'} />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ marginTop: 35 }}
        >
          <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>

                <Grid container spacing={2}>
                  <Grid item xs={11}>
                    <div style={{
                      display: 'flex',
                      marginBottom: 20,
                      marginTop: 60
                    }}>
                      <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 30, paddingLeft: 10 }}>CDD RBM</Typography>
                    </div>
                  </Grid>
                </Grid>

                {/*FILTER DROPDOWNS*/}
                <Grid container spacing={2}>
                  <Grid item xs={1} style={{ fontSize: "18px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                    Company
                  </Grid>
                  <Grid item xs={3}>

                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedCompany}
                      onChange={e => this.setState({ SelectedCompany: e.target.value }, this.FntoSetProductypes(e.target.value))}
                    >
                      {this.state.CompanyType.map(team => (
                        <MenuItem value={team.COMPANY}>{team.COMPANY}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField fullWidth label="Client No" value={this.state.SelectedClientName} onChange={(e) => this.handeltextChange(e, "SelectedClientName")} variant="outlined" />
                  </Grid>
                  <Grid item xs={1} style={{ fontSize: "18px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                    ClientType</Grid>
                  <Grid item xs>
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedClientType}
                      onChange={e => this.setState({ SelectedClientType: e.target.value },
                        this.fnsetclientType(e.target.value)
                      )}
                    >
                      {this.state.ClientType.map(team => (
                        <MenuItem value={team.CLIENTTYPE}>{team.CLIENTTYPE}</MenuItem>
                      ))}
                    </Select>
                  </Grid>

                </Grid>
                <Grid container spacing={2}>

                  <Grid item xs={1}>
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedNICType}
                      onChange={e => this.setState({ SelectedNICType: e.target.value, SelectedNicLabel: e.target.value },
                        this.FntocheckpassDrop(e.target.value))}
                    >
                      {this.state.NICdrop.map(team => (
                        <MenuItem value={team.GRP_VALUES}>{team.GRP_VALUES}</MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={3}>
                    <TextField fullWidth label={this.state.SelectedNicLabel} value={this.state.SelectedNic} variant="outlined" onChange={(e) => this.handeltextChange(e, "SelectedNic")} />
                  </Grid>
                  <Grid item xs={1} style={{ fontSize: "18px", fontFamily: 'Globerbold', color: BLUE_COLOR, display: this.state.displaycountry }} >
                    Country
                  </Grid>
                  <Grid item xs={3} style={{ display: this.state.displaycountry }}>

                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.selectedDropCountry}
                      onChange={e => this.setState({ selectedDropCountry: e.target.value }
                      )}
                    >
                      {this.state.Dropcountry.map(team => (
                        <MenuItem value={team.CODE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>             </Grid>

                  <Grid item xs >
                    <RadioGroup primary row aria-label="" name="v"  >
                      <FormControlLabel value="ONBOARDING" control={<Radio color="primary" disabled={this.state.diableRadio} onChange={e => this.setRadioState(e.target.value)} checked={this.state.selectedOption === "ONBOARDING"} />} label="ONBOARDING" />
                      <FormControlLabel value="BENEFITPAYABLE" control={<Radio disabled={this.state.diableRadio} onChange={e => this.setRadioState(e.target.value)} checked={this.state.selectedOption === "BENEFITPAYABLE"} color="primary" />} label="BENEFIT PAYABLE" />
                    </RadioGroup>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    <TextField fullWidth label="Date" value={this.state.selectedDate} variant="filled" />
                  </Grid>
                  <Grid item xs>
                    <TextField fullWidth label="Risk Profile" value={this.state.riskProfile} variant="filled" InputProps={{ readOnly: true, }} />
                  </Grid>
                  <Grid item xs>
                    Is Admin
                    <Switch disabled={this.state.isadminSwitch}
                      checked={this.state.isadmin}
                      onChange={e => this.handleChange(e)}
                      color="primary"
                      name="checkedB"
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                  </Grid>
                </Grid>
                <Divider style={{ marginTop: 15 }} />
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    {/* <EditableLabel
                            initialValue={'Client Owner Type :'}
                            save={value => {
                                console.log(`Saving '${value}'`);
                            }}
                        /> */}
                    Client Owner Type :
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedOwnerType}
                      onChange={e => this.setState({
                        SelectedOwnerType: e.target.value,
                        SelectedOwnerTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.OWNERTYPE.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedOwnerTypeSCORE}</h3>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    {this.state.selectedProductLabel}
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedProductType}
                      onChange={e => this.setState({
                        SelectedProductType: e.target.value,
                        SelectedProductTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.PRODUCT.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedProductTypeSCORE}</h3>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    {this.state.selectedPremiumLabel}
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth disabled={this.state.disableSelectedpaymentType}
                      variant={'outlined'}
                      value={this.state.SelectedPREMIUMType}
                      onChange={e => this.setState({
                        SelectedPREMIUMType: e.target.value,
                        SelectedPREMIUMTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.PREMIUM.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                      {this.state.Nainpayment ? "" :
                        <MenuItem value="NA" data-score={0}>Not Applicable</MenuItem>
                      }

                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedPREMIUMTypeSCORE}</h3>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    Country of Incorporation/Nationality of Client :
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedNATIONALITYType}
                      onChange={e => this.setState({
                        SelectedNATIONALITYType: e.target.value,
                        SelectedNATIONALITYTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.NATIONALITY.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedNATIONALITYTypeSCORE}</h3>
                  </Grid>
                </Grid>  <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    Residential Location/ Registered Address of Client :
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedCOUNTRYYType}
                      onChange={e => this.setState({
                        SelectedCOUNTRYYType: e.target.value,
                        SelectedCOUNTRYTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.COUNTRY.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedCOUNTRYTypeSCORE}</h3>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    What is the target sector of the client/company?
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedTSECTORType}
                      onChange={e => this.FnforotherOccupation("BENEFSLL", e)}
                    >
                      {this.state.TSECTOR.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedTSECTORTypeSCORE}</h3>
                  </Grid>
                </Grid>
                {this.state.ShowOccupation ?
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      Others Occupation (please specify)
                    </Grid>
                    <Grid item xs >
                      <Typography style={{ fontFamily: "Globerbold", color: MODIFIEDBLACK, fontSize: 16 }}><FormControl fullWidth>
                        <TextField label="" style={{ width: '100%' }}
                          value={this.state.SelectedTSECTORText}
                          onChange={(e) => this.handeltextChange(e, "SelectedTSECTORText")}
                          inputProps={{
                            maxLength: 50,
                          }}
                           />
                      </FormControl></Typography>
                    </Grid>
                    <Grid item xs>
                      {/* <h3 style={{display:this.state.isadmin? "":"none"}}> {this.state.SelectedTSECTORTypeSCORE}</h3> */}
                    </Grid>
                  </Grid>
                  : null}
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    What is the source of introduction?
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth disabled={this.state.disableSelectedINTROType}
                      variant={'outlined'}
                      value={this.state.SelectedINTROType}
                      onChange={e => this.setState({
                        SelectedINTROType: e.target.value,
                        SelectedINTROTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.INTRO.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                      {this.state.NANSourceOfIntroduction ? "" :
                        <MenuItem value="NA" data-score={0}>Not Applicable</MenuItem>
                      }
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedINTROTypeSCORE}</h3>
                  </Grid>
                </Grid>

                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    Source of funds to be introduced :
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth disabled={this.state.disableSelectedINTROType}
                      variant={'outlined'}
                      value={this.state.SelectedSRCFUNDType}
                      onChange={e => this.setState({
                        SelectedSRCFUNDType: e.target.value,
                        SelectedSRCFUNDTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.SRCFUND.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                      {this.state.NANSourceOfFund ? "" :
                        <MenuItem value="NA" data-score={0}>Not Applicable</MenuItem>
                      }
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedSRCFUNDTypeSCORE}</h3>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    Is the client a PEP or linked to a PEP?
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedPEPType}
                      onChange={e => this.setState({
                        SelectedPEPType: e.target.value,
                        SelectedPEPTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.PEP.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedPEPTypeSCORE}</h3>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    Is the applicant listed on AML watchlist?
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth placeholder={'Select Plan'}
                      variant={'outlined'}
                      value={this.state.SelectedAMl}
                      onChange={e => this.setState({
                        SelectedAMl: e.target.value,
                        SelectedAMLSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.AML.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedAMLSCORE}</h3>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs>
                    Is it a complex structure?
                  </Grid>
                  <Grid item xs >
                    <Select fullWidth
                      variant={'outlined'}
                      value={this.state.SelectedCOMPLEXType}
                      onChange={e => this.setState({
                        SelectedCOMPLEXType: e.target.value,
                        SelectedCOMPLEXTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                      })}
                    >
                      {this.state.COMPLEX.map(team => (
                        <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs>
                    <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedCOMPLEXTypeSCORE}</h3>
                  </Grid>
                </Grid>
                {/*              
            <Grid container  spacing={2} style={{marginTop:10}}>
              <Grid item xs>
              Country of incorporation of the company :
              </Grid>
              <Grid item xs >
              <Select fullWidth 
                        variant={'outlined'}
                        value={this.state.SelectedCINCORPType}
                        onChange={e=>this.setState({SelectedCINCORPType:e.target.value,
                        SelectedCINCORPTypeSCORE:Number(e.currentTarget.getAttribute('data-score')) 
                      })}
                      >
                  {this.state.CINCORP.map(team => (
               <MenuItem value={team.CODE} data-score= {team.SCORE}>{team.DESCRIPTION}</MenuItem>
                  ))}
                 </Select>
              </Grid>
              <Grid item xs> 
              <h3 style={{display:this.state.isadmin? "":"none"}}> {this.state.SelectedCINCORPTypeSCORE}</h3>
              </Grid>
            </Grid> 
             */}
                {this.state.showBeneficiaryComponent ?
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      {this.state.selectedbeneficiaryLabel}
                    </Grid>
                    <Grid item xs >
                      <Select fullWidth disabled={this.state.disableBenef}
                        variant={'outlined'}
                        value={this.state.SelectedBENEFType}
                        onChange={e => this.setState({
                          SelectedBENEFType: e.target.value,
                          SelectedBENEFTypeSCORE: Number(e.currentTarget.getAttribute('data-score'))
                        })}
                      >
                        {this.state.BENEF.map(team => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>{team.DESCRIPTION}</MenuItem>
                        ))}
                        {this.state.NANBenef ? "" :
                          <MenuItem value="NA" data-score={0}>Not Applicable</MenuItem>
                        }
                      </Select>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}> {this.state.SelectedBENEFTypeSCORE}</h3>
                    </Grid>
                  </Grid>
                  : null}
                <Divider style={{ marginTop: 15 }} />

                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  <Grid item xs></Grid>
                  <Grid item xs></Grid>
                  <Grid item xs>
                    {this.state.showNewCDDC ?
                      <Button variant={'text'} onClick={(e) => this.handleNewCDDClick(e)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '30%', fontSize: 18 }}>
                        New CDD
                      </Button> : null}

                    <Button variant={'text'} disabled={this.state.SavebuttonDisable} onClick={(e) => this.handleSearchClick(e)} style={{ color: 'white', marginLeft: '10px', fontFamily: 'Globerbold', backgroundColor: this.state.savebuttonbackcolor, width: '30%', fontSize: 18 }}>
                      Save
                    </Button>
                    <Button variant={'text'} onClick={(e) => this.handleCancelClick(e)} style={{ color: 'white', marginLeft: '10px', fontFamily: 'Globerbold', backgroundColor: this.state.savebuttonbackcolor, width: '30%', fontSize: 18 }}>
                      Cancel
                    </Button>
                    {/* <Button onClick={() => window.print()}>PRINT</Button> */}

                    {/*FILTER DROPDOWNS*/}
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 20 }}></Grid>
              </div>
              <Dialog
                open={this.state.showalertPopup}
                onClose={(e) => this.setState({ showalertPopup: false })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title" style={{ fontSize: "20px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                  {"Please Confirm!"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" style={{ fontFamily: 'Globerbold' }}>
                    Kindly ensure that all questions have been correctly answered before saving data.“Do you want to go back to edit your answers on the RBA?”
                  </DialogContentText>
                </DialogContent>
                <DialogActions>

                  <Button variant={'text'} onClick={(e) => this.handlesetalert("YES")} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: VIBRANT_GREEN, width: '30%', fontSize: 18 }}>
                    YES
                  </Button>
                  <Button variant={'text'} onClick={(e) => this.handlesetalert("NO")} style={{ color: 'white', marginLeft: '10px', fontFamily: 'Globerbold', backgroundColor: RED_COLOR, width: '30%', fontSize: 18 }}>
                    NO
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Paper>
        </Box>
      </Fragment>
    )
  }
}